import React from 'react';

function ArrowIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.6001 20C9.3001 20 9.1001 19.9006 8.9001 19.7019C8.5001 19.3043 8.5001 18.7081 8.9001 18.3106L15.2001 11.9503L8.9001 5.68944C8.5001 5.29193 8.5001 4.69565 8.9001 4.29814C9.3001 3.90062 9.9001 3.90062 10.3001 4.29814L17.3001 11.2547C17.5001 11.4534 17.6001 11.6522 17.6001 11.9503C17.6001 12.2484 17.5001 12.4472 17.4001 12.646L10.4001 19.6025C10.1001 19.9006 9.9001 20 9.6001 20Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default ArrowIcon;
